import React, { useState } from "react";
import { Button, TextField } from "@mui/material";
import FusionAuthClient from "@fusionauth/typescript-client";

function Login({ setUserLoggedIn }) {
    const [userName, setUserName] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState(false);

    const login = async () => {
        const client = new FusionAuthClient("ylZduCvelbZEXxLAQG4t_NKSlgBaWyfIkVJQ8xU7aROe9XKzeAk9_KKR", "https://p6pp-auth.planetpop-qr.net");
        setError(false);
        try {
            const response = await client.login({
                loginId: userName,
                password,
                applicationId: "957bf93f-67dd-4b8f-8433-ee4ec7fabfed",
            });
            if (response.wasSuccessful()) {
                setUserLoggedIn(true);
            } else {
                setError(true);
            }
        } catch (e) {
            console.log("error logging in user: ", e);
            setError(true);
        }
    };
    return (
        <div>
            <div style={{ flexDirection: "column", display: "flex", justifyContent: "center", alignItems: "center", marginTop: 200 }}>
                <TextField
                    label={"User Name"}
                    value={userName}
                    error={error}
                    margin={"normal"}
                    style={{ width: 400 }}
                    InputLabelProps={{ shrink: true }}
                    onChange={(event) => setUserName(event.target.value)}
                />
                <TextField
                    label={"Passwort"}
                    value={password}
                    type={"password"}
                    error={error}
                    margin={"normal"}
                    style={{ width: 400 }}
                    InputLabelProps={{ shrink: true }}
                    onChange={(event) => setPassword(event.target.value)}
                />
                {error ? <p>Incorrect username or password</p> : null}
                <Button variant={"contained"} onClick={login}>
                    {"Log In"}
                </Button>
            </div>
        </div>
    );
}

export default Login;

